import { gql } from "apollo-boost";

const AMBASSADOR_SEND_INFO_EMAIL = gql`
  mutation ambassadorSendInfoMail($ambassadorId: ID!) {
    ambassadorSendInfoMail(ambassadorId: $ambassadorId)
  }
`;

export default AMBASSADOR_SEND_INFO_EMAIL;
